import type { TConfigStyle } from './widgets/cpas-exchange-rates-table/models';

export const desktopConfig: TConfigStyle = {
    headerBlock: {
        align: 'center',
        styler: { padding: 0, marginBottom: 24 },
    },
    tabsBlock: {
        align: 'center',
        styler: { padding: 0, marginBottom: 0 },
    },
    tableBlock: {
        true: {
            styler: {
                paddingBottom: 40,
                paddingTop: 40,
                paddingLeft: 48,
                paddingRight: 48,
            },
        },
        false: {
            styler: {
                paddingBottom: 40,
                paddingTop: 40,
                paddingLeft: 48,
                paddingRight: 48,
            },
        },
    },
};

export const mobileConfig: TConfigStyle = {
    headerBlock: {
        align: 'left',
        styler: { paddingLeft: 16, paddingRight: 16, marginBottom: 24 },
    },
    tabsBlock: {
        align: 'left',
        styler: { marginBottom: 0 },
    },
    tableBlock: {
        false: {
            styler: {
                paddingBottom: 24,
                paddingTop: 24,
                paddingLeft: 16,
                paddingRight: 16,
            },
        },
        true: {
            styler: {
                paddingBottom: 16,
                paddingTop: 16,
                paddingLeft: 16,
                paddingRight: 16,
            },
        },
    },
};

export const DEFAULT_COLUMN_NAMES = ['Валюта', 'Покупка', 'Продажа'];
